import PhysicalProducts from "./PhysicalProducts.js";
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import DigitalProducts from "./DigitalProducts.js";
import BasketCheckout from "./BasketCheckout.js";
import "./styles.css";

// 1. Home Page Component Layout
function HomePage({ setIsOpen }) {
  return (
    <div className="container">
      {/* Main Header */}
      <div className="logo-area">
        <h1 className="main-title">DoodleBugg</h1>
        <div className="subtitle">D E P O T</div>
      </div>

      {/* Welcome Block */}
      <div className="welcome-badge">Welcome</div>

      <p className="prompt-text">Are you looking for</p>

      {/* Redirect Buttons */}
      <div className="button-grid">
        <Link to="/digital-products" className="btn btn-digital">
          Digital products
        </Link>

        <a href="/physical-products" className="btn btn-physical">
          Physical products
          <span className="btn-subtext">(UK only)</span>
        </a>
      </div>

      {/* Contact Section & Pop-up Trigger */}
      <div className="contact-section">
        <p className="contact-text">
          Contact us about listing your products on Orbix.
        </p>
        <button className="btn btn-wide" onClick={() => setIsOpen(true)}>
          Contact Orbix
        </button>
      </div>
    </div>
  );
}

// 2. Main Controller managing Page Paths & Contact Modal
function App() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage setIsOpen={setIsOpen} />} />
        <Route path="/digital-products" element={<DigitalProducts />} />
        <Route path="/physical-products" element={<PhysicalProducts />} />{" "}
        {/* 🌟 Add this line */}
      </Routes>

      {/* Contact Form Pop-up (Global Modal) */}
      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsOpen(false)}>
              &times;
            </button>
            <h3>Contact Orbix</h3>

            <form
              action="https://formsubmit.co/OrbixIT@outlook.com"
              method="POST"
            >
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  required
                ></textarea>
              </div>
              <button type="submit" className="form-submit">
                Send Email
              </button>
            </form>
          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
